import {
    SHOP_PRODUCTS_LOAD_ERROR,
    SHOP_PRODUCTS_LOAD_REQUEST,
    SHOP_PRODUCTS_LOAD_SUCCESS,
    SHOP_PURCHASE_ERROR,
    SHOP_PURCHASE_REQUEST,
    SHOP_PURCHASE_SUCCESS,
    SHOP_STATUS_LOAD_ERROR,
    SHOP_STATUS_LOAD_REQUEST,
    SHOP_STATUS_LOAD_SUCCESS,
} from 'state/actions/shop'

export const initialState = {
    products: [],
    status: null,
    errorMessage: null,
    productsLoading: false,
    productsLoaded: false,
    statusLoading: false,
    statusLoaded: false,
    purchaseInProgress: false,
}

// eslint-disable-next-line complexity
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case SHOP_PRODUCTS_LOAD_REQUEST: {
        return {
            ...state,
            productsLoading: true,
            productsLoaded: false,
            errorMessage: null,
        }
    }
    case SHOP_PRODUCTS_LOAD_SUCCESS: {
        return {
            ...state,
            productsLoading: false,
            productsLoaded: true,
            products: action.payload.data || state.products,
            status: {
                ...state.status,
                ...action.payload.meta,
            },
        }
    }
    case SHOP_PRODUCTS_LOAD_ERROR: {
        return {
            ...state,
            productsLoading: false,
            productsLoaded: false,
            errorStatus: action.payload.statusCode,
            errorMessage: action.payload.errorMessage,
        }
    }
    case SHOP_STATUS_LOAD_REQUEST: {
        return {
            ...state,
            statusLoading: true,
            statusLoaded: false,
            errorMessage: null,
        }
    }
    case SHOP_STATUS_LOAD_SUCCESS: {
        return {
            ...state,
            statusLoading: false,
            statusLoaded: true,
            status: {
                ...state.status,
                ...action.payload,
            },
        }
    }
    case SHOP_STATUS_LOAD_ERROR: {
        return {
            ...state,
            statusLoading: false,
            statusLoaded: false,
            errorStatus: action.payload.statusCode,
            errorMessage: action.payload.errorMessage,
        }
    }
    case SHOP_PURCHASE_REQUEST: {
        return {
            ...state,
            purchaseInProgress: true,
            errorMessage: null,
        }
    }
    case SHOP_PURCHASE_SUCCESS: {
        const productId = action.payload
        const products = state.products.map((product) => {
            if (product.id === productId) {
                return {
                    ...product,
                    count_left: product.count_left - 1,
                }
            } else {
                return product
            }
        })

        return {
            ...state,
            purchaseInProgress: false,
            products,
        }
    }
    case SHOP_PURCHASE_ERROR: {
        return {
            ...state,
            purchaseInProgress: false,
            errorStatus: action.payload.statusCode,
            errorMessage: action.payload.errorMessage,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/shop.js